enum StoryblokVersion {
  published = "published",
  draft = "draft",
}

const version = StoryblokVersion[import.meta.env.VITE_STORYBLOK_VERSION as keyof typeof StoryblokVersion];

if (version !== StoryblokVersion.published && version !== StoryblokVersion.draft) {
  throw new Error(`Invalid VITE_STORYBLOK_VERSION value: ${version}`);
}

export const AppConfig = {
  user: {
    defaultMarket: "WWA",
    defaultLanguage: "EN",
  },
  storyBlok: {
    accessToken: import.meta.env.VITE_STORYBLOK_API_TOKEN!,
    previewAccessToken: import.meta.env.VITE_STORYBLOK_API_PREVIEW_TOKEN!,
    sharedComponentDataSlug: "sharedcomponentdata",
    homePageSlug: "home",
    version: version,
    datasourceEntries: "cdn/datasource_entries",
  },
  api: {
    quotation: import.meta.env.VITE_QUOTATION_API!,
    efPlanner: import.meta.env.VITE_EF_PLANNER_API_URL!,
    productWebsite: import.meta.env.VITE_PRODUCT_WEBSITE_API_URL!,
    atlasWebsite: import.meta.env.VITE_ATLAS_WEBSITE_URL!,
    centralApi: import.meta.env.VITE_CENTRAL_API!,
    dataApi: import.meta.env.VITE_DATA_API!,
    customerServiceApi: import.meta.env.VITE_CUSTOMER_SERVICE_API!,
    martechApi: import.meta.env.VITE_MARTECH_API_URL!,
    productCatalogApi: import.meta.env.VITE_PRODUCT_CATALOG_API_URL!,
  },
  sessionStorageKeys: {
    authToken: "authToken",
    jwtToken: "access_token",
  },
  oraclePaymentLibrary: {
    paymentReturnUrlHost: import.meta.env.VITE_ORACLE_PAYMENT_RETURN_URL!,
    source: import.meta.env.VITE_ORACLE_PAYMENT_LIBRARY_SOURCE!,
    integrity: import.meta.env.VITE_ORACLE_PAYMENT_LIBRARY_INTEGRITY!,
  },
  atlas: {
    defaultLanguage: "en",
  },
  efcom: {
    defaultMarket: "we",
    defaultProgramCode: "ils",
  },
  content: {
    defaultLanguage: "en",
    logoImageUrl: "https://media.ef.com/1fiz5hXLt5pFhrk62j4k3Ly3m_sZWUyMzljZGJmYmM0NDE1/logo-black.svg",
    defaultBannerImage: "https://media.ef.com/1fiXyCE3SzAChLnnktr7g7vtr_sMjRmMDEwNzFmYzVhYjI5/hero.webp",
    defaultSchoolImage: "https://media.ef.com/1fiXyCE3SzAChLnnktr7g7vtr_sMjRmMDEwNzFmYzVhYjI5/hero.webp",
    defaultThankYouImage: "https://media.ef.com/1fizhoypFXCopCovqSpyhvL62_sMzk3YjQ5YjIxMWVjNGFm/thankyouimage.webp",
  },
  cookieConsent: {
    domainScriptId: import.meta.env.VITE_ONETRUST_DOMAIN_SCRIPT_ID!,
    onetrustSource: "https://www.ef.com/onetrust/scripttemplates/otSDKStub.js",
  },
  analytics: {
    googleMeasurementId: import.meta.env.VITE_GOOGLE_MEASUREMENT_ID!,
  },
  rum: {
    APPLICATION_ID: import.meta.env.VITE_RUM_APPLICATION_ID,
    APPLICATION_VERSION: import.meta.env.VITE_RUM_APPLICATION_VERSION,
    APPLICATION_REGION: import.meta.env.VITE_RUM_APPLICATION_REGION,
    IDENTITY_POOL_ID: import.meta.env.VITE_RUM_IDENTITY_POOL_ID,
  },
  environment: import.meta.env.VITE_ENVIRONMENT!,
};
